import React, { useState } from "react";
import SearchIcon from "@patternfly/react-icons/dist/js/icons/search-icon";
import { InputGroup, InputGroupText, TextInput } from "@patternfly/react-core";

export default (props) => {
  const [value, setValue] = useState("");

  function handleFilterChange(value) {
    setValue(value);
    props.onChange && props.onChange(value);
  }

  return (
    <InputGroup>
      <TextInput
        name="product-suite-filter"
        placeholder={`Find ${props.itemName}`}
        value={value || ""}
        type="text"
        onChange={handleFilterChange}
        aria-label="Product Suite filter"
      />
      <InputGroupText component="label" htmlFor="product-suite-filter">
        <SearchIcon />
      </InputGroupText>
    </InputGroup>
  );
};
